import React from 'react';
import './dots.css'

const Dots = () => {
    return (<div className="dots-container">
        <div id="dot__1">&bull;</div>
        <div id="dot__2">&bull;</div>
        <div id="dot__3">&bull;</div>
    </div>)
}

export default Dots;